export default __webpack_public_path__ + "static/media/portfolio-169.1519abbd.jpg";